/**
 * Placeholder segment used in module query keys while no client is selected.
 */
const NO_CLIENT = 'no-client';

/**
 * Builds the root of a module's React Query keys: `[moduleId, 'client', clientId]`.
 *
 * Every module key starts with this root, so all cached module data is scoped
 * per client and a whole module (or client) can be invalidated at once.
 *
 * @example
 * export const paymentModuleKeys = {
 *   ...createModuleQueryKeys('payment-module'),
 *   payments: (clientId: string | null) => [...paymentModuleKeys.all(clientId), 'payments'] as const,
 * };
 *
 * @param moduleId - The module's unique ID (must match the `id` in its definition)
 */
export function createModuleQueryKeys<const TModuleId extends string>(moduleId: TModuleId) {
  return {
    /** Root key for all of this module's queries for one client. */
    all: (clientId: string | null) => [moduleId, 'client', clientId ?? NO_CLIENT] as const,
  };
}
